import { format, addDays, isWeekend, isSameDay, parse, isValid } from 'date-fns';


// Function to detect and parse date strings
export const parseDate = (dateString) => {
    // Regular expressions for common date formats
    const yyyyMmDdFormat = /^\d{4}-\d{2}-\d{2}$/; // yyyy-MM-dd
    const mmDdYyyyFormat = /^\d{2}\/\d{2}\/\d{4}$/; // MM/dd/yyyy
    const ddMmYyyyFormat = /^\d{2}\/\d{2}\/\d{4}$/; // dd/MM/yyyy

    let parsedDate;

    if (yyyyMmDdFormat.test(dateString)) {
        // Parse yyyy-MM-dd format
        parsedDate = parse(dateString, 'yyyy-MM-dd', new Date());
    } else if (mmDdYyyyFormat.test(dateString)) {
        // Parse MM/dd/yyyy format
        parsedDate = parse(dateString, 'MM/dd/yyyy', new Date());
    } else if (ddMmYyyyFormat.test(dateString)) {
        // Parse dd/MM/yyyy format
        parsedDate = parse(dateString, 'dd/MM/yyyy', new Date());
    } else {
        throw new Error(`Unsupported date format: ${dateString}`);
    }

    // Validate the parsed date
    if (!isValid(parsedDate)) {
        throw new Error(`Invalid date: ${dateString}`);
    }

    return parsedDate;
};

export const normalizeDate = (date) => {
    const [year, month, day] = date.split('-');
    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
};

export const isBusinessDay = (date, weekends, holidays) => {
    const dayOfWeek = date.getDay();
    const formattedDate = format(date, 'yyyy-MM-dd'); // Use yyyy-MM-dd
    const holidayDates = holidays.map(holiday => format(holiday, 'yyyy-MM-dd')); // Normalize holidays
    return !weekends.includes(dayOfWeek) && !holidayDates.includes(formattedDate);
};

export const getPreviousBusinessDay = (date, weekends, holidays) => {
    let prevDate = addDays(date, -1); // Move back one day
    while (!isBusinessDay(prevDate, weekends, holidays)) {
        prevDate = addDays(prevDate, -1);
    }
    return prevDate;
};

export const getNextBusinessDay = (date, weekends, holidays) => {
    let nextDate = addDays(date, 1); // Move forward one day
    while (!isBusinessDay(nextDate, weekends, holidays)) {
        nextDate = addDays(nextDate, 1);
    }
    return nextDate;
};

export const calculateWorkingDays = (startDate, endDate, weekends, holidays) => {
    let count = 0;
    let currentDate = new Date(startDate);

    // Normalize holidays
    const holidayDates = holidays.map(date => format(date, 'yyyy-MM-dd'));

    while (currentDate <= endDate) {
        const currentDay = currentDate.getDay();
        const currentDateFormatted = format(currentDate, 'yyyy-MM-dd');

        if (!weekends.includes(currentDay) && !holidayDates.includes(currentDateFormatted)) {
            count++;
        }

        currentDate = addDays(currentDate, 1); // Move to the next day
    }

    return count;
};

export const formatDate = (date) => {
    return date.toLocaleDateString("en-US", { weekday: 'short', month: 'short', day: '2-digit', year: 'numeric' });
};

export const formatHolidays = (holidays) => {
    return holidays.map(date => new Date(date).toLocaleDateString("en-US"));
};

export const formatCurrency = (value) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };
  
  // Helper function to format hours
export  const formatHours = (value) => {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value) + "H";
  };

  export const resetMatrixFormData = (formData) => ({
    ...formData,
    allocationMatrix: [],
    resourceTable: [],
    resourceAllocationGrid: [], // Reset to initial state
  });

  
  export const resetMatrix = (setFormData) => {
    setFormData((prevData) => ({
      ...prevData,
      allocationMatrix: [],
      resourceTable: [],
      resourceAllocationGrid: [], // Reset to initial state
    }));
  };
  